import { useQuery } from '@apollo/client'
import { Box, Button, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import NoItemsAvailableCard from '../../../Components/Cards/NoItemsAvailableCard'
import { GET_ALL_PROPERTIES } from '../../../Components/Graphql/Queries'

const thStyles = {
  fontSize: '14px',
  fontWeight: 'bold',
  textTransform: 'none',
  color: 'black',
  padding: '8px'
}

const tdStyles = {
  fontSize: '14px',
  fontWeight: '400',
  color: '#212529',
  padding: '8px'
}

const ListedProperties = () => {
  let navigate = useNavigate();
  const { error, loading, data } = useQuery(GET_ALL_PROPERTIES, { fetchPolicy: 'network-only' });
  const [listedProperties, setListedProperties] = useState([]);

  useEffect(() => {
    if (data !== undefined) {
      console.log("Data from listed properties: ", data);
      setListedProperties(data.getAllSubmitProperty);
    }
    if (error !== undefined) {
      console.log("Error from listed properties: ", error);
    }
  }, [error, loading, data]);

  return (
    <Box w='100%'>
      <Text fontSize='20px' color='#333' marginLeft='30px' marginBottom='10px'>
        Listed Properties
      </Text>
      <Box color='#315B84' background='#FFFFFF' padding='20px 25px 15px 25px' w='100%' borderRadius='15px'>
        {listedProperties.length > 0 ? (
          <TableContainer>
            <Table variant='simple'>
              <Thead>
                <Tr>
                  <Th {...thStyles}>Name</Th>
                  <Th {...thStyles}>Ticker ID</Th>
                  <Th {...thStyles}>Status</Th>
                  <Th {...thStyles}>.</Th>
                </Tr>
              </Thead>
              <Tbody>
                {listedProperties.map((property, index) => (
                  <Tr key={index}>
                    <Td {...tdStyles}><Text>{property.name}</Text></Td>
                    <Td {...tdStyles}><Text>{property.tickerSymbol}</Text></Td>
                    <Td {...tdStyles}><Text>{property.propertyStatus}</Text></Td>
                    <Td {...tdStyles}>
                      <Button
                        onClick={() => navigate(`/property/${property.id}`)}
                        fontWeight='300'
                        backgroundColor='#0d6efd'
                        color='white'
                        _hover={{
                          backgroundColor: '#0a58ca'
                        }}
                        padding='4px 8px'
                        fontSize='14px'
                      >
                        View
                      </Button>
                    </Td>
                  </Tr>
                ))}
                {/* <Tr>
                <Td {...tdStyles}>Home 2 Suites</Td>
                <Td {...tdStyles}>RSH2</Td>
                <Td {...tdStyles}>Express Interest</Td>
                <Td {...tdStyles}>
                  <Button
                    fontWeight='300'
                    backgroundColor='#0d6efd'
                    color='white'
                    _hover={{
                      backgroundColor: '#0a58ca'
                    }}
                    padding='4px 8px'
                    fontSize='14px'
                  >
                    View
                  </Button>
                </Td>
              </Tr> */}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <NoItemsAvailableCard />
        )}
      </Box>
    </Box>
  )
}

export default ListedProperties